import Container from './Layout/Container';
import { Grid } from '@mui/material';

function Impressum() {
    return (
        <Container>
            <Grid container spacing={1}>
                <Grid item>
                    <div>
                        <h1>IMPRESSUM</h1>
                        The following information (Impressum) is required under German law.
                        <p>
                            ANGABEN GEMÄSS § 5 TMG <br />
                            Unetiq GmbH
                            <br />
                            Rosenheimer Str. 139
                            <br />
                            81671 München
                        </p>
                        <p>
                            Handelsregister: 241994
                            <br />
                            Registergericht: Amtsgericht München
                        </p>
                        <p>
                            Vertreten durch den Geschäftsführer:
                            <br />
                            Karens Grigorjancs
                        </p>
                        <h2>KONTAKT</h2>
                        <p>
                            Telefon: 089 215 39 144
                            <br />
                            E-Mail: info@unetiq.com
                        </p>
                        <h2>UMSATZSTEUER</h2>
                        <p>
                            Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
                            <br />
                            DE319410974
                        </p>
                        <h2>STREITSCHLICHTUNG</h2>
                        <p>
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                            <a style={{ color: 'var(--primary)' }} href="https://ec.europa.eu/consumers/odr">
                                https://ec.europa.eu/consumers/odr
                            </a>
                        </p>
                        Unsere E-Mail-Adresse finden Sie oben im Impressum.
                        <br />
                        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle teilzunehmen.
                        <h2>HAFTUNG FÜR INHALTE</h2>
                        <p>
                            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach
                            den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
                            jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen
                            oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                        </p>
                        <p>
                            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                            allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
                            ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden
                            von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                        </p>
                        <h2>HAFTUNG FÜR LINKS</h2>
                        <p>
                            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
                            Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
                            Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                            mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
                            nicht erkennbar.
                        </p>
                        <p>
                            Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                            Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                            Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                        </p>
                        <h2>URHEBERRECHT</h2>
                        <p>
                            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                            deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung
                            des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den
                            privaten, nicht kommerziellen Gebrauch gestattet.
                        </p>
                        <p>
                            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
                            Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
                            gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                            bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
                            wir derartige Inhalte umgehend entfernen.
                        </p>
                        Quelle:
                        <br />
                        <a style={{ color: 'var(--primary)' }} href="https://www.e-recht24.de/">
                            eRecht24
                        </a>
                    </div>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Impressum;
